<template>
  <div class="loader-container">
    <div :class="{ loader01: !smallar, 'loader-small': smallar }"></div>
  </div>
</template>

<script>
/**
 * The Loader for Component Level Loading
 */
export default {
  name: 'Loading',
  props: {
    smallar: { default: false, type: Boolean }
  }
};
</script>

<style lang="scss" scoped>
$spinner-size: 3.5rem; //height, width
$spinner-thikness: 0.5rem;
$smaller-spinner-size: 1.5rem; //height, width
$smaller-spinner-thikness: 0.2rem;

.loader01 {
  width: $spinner-size;
  height: $spinner-size;
  border: $spinner-thikness solid $font-primary;
  border-right-color: transparent;
  border-radius: 50%;
  animation: loader-rotate 1s linear infinite;
  margin: auto;
}
.loader-small {
  width: $smaller-spinner-size;
  height: $smaller-spinner-size;
  border: $smaller-spinner-thikness solid $font-primary;
  border-right-color: transparent;
  border-radius: 50%;
  animation: loader-rotate 1s linear infinite;
  margin: auto;
}
// .loader01:after {
//   content: '';
//   width: $spinner-thikness;
//   height: $spinner-thikness;
//   background: $font-primary;
//   border-radius: 50%;
//   position: absolute;
//   top: -0.0625rem;
//   left: 2.0625rem;
// }

@keyframes loader-rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader-container {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
